"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data_structures_1 = require("@tableau/data-structures");
/**
 *  Re-implemented from lodash/underscore so we don't have to depend on the entire library,
 *  which bloats the file size of the module
 */
// tslint:disable-next-line:no-any
function groupBy(items, getKey) {
    var result = {};
    items.forEach(function (item) {
        var key = '' + getKey(item);
        if (result.hasOwnProperty(key)) {
            result[key].push(item);
        }
        else {
            result[key] = [item];
        }
    });
    return result;
}
/**
 * The input list of project objects implies a hierarchy (based on the parentProjectId field),
 * but projects' children could be anywhere in the array relative to their parent. This function
 * converts such a flat list into a tree that represents the hierarchy and preserves siblings'
 * ordering relative to each other.
 */
function convertProjectListToTrees(projects) {
    var topLevelProjects = projects.filter(function (p) { return p.topLevelProject; });
    var projectsByParent = groupBy(projects, function (p) { return p.parentProjectId; });
    function buildDescendantTreeFromProject(project, nestingLevel) {
        var childProjects = projectsByParent[project.id];
        return new data_structures_1.RoseTree(convertProjectToBasicInfo(project, nestingLevel), childProjects ? childProjects.map(function (p) { return buildDescendantTreeFromProject(p, nestingLevel + 1); }) : []);
    }
    // Root nesting level is 1 because the top-level projects are all children of the site,
    // which occupies level 0 in the nested projects datagrid.
    return topLevelProjects ? topLevelProjects.map(function (p) { return buildDescendantTreeFromProject(p, 1); }) : [];
}
exports.convertProjectListToTrees = convertProjectListToTrees;
function convertProjectToBasicInfo(project, nestingLevel) {
    return {
        id: project.id,
        parentId: project.parentProjectId,
        name: project.name,
        nestingLevel: nestingLevel,
        hasChildren: project.childProjectCount > 0,
        status: project.status
    };
}
//# sourceMappingURL=NestedProjectsTreeHelper.js.map